import React from 'react'
import PropTypes from 'prop-types'
import styles from './RecommendItem.module.scss'
import classNames from 'classnames/bind'
import { Box, Button, CardMedia } from '@mui/material'
import SubtractIcon from '~/assets/icons/FoodDetail/SubtractIcon'
import AddIcon from '~/assets/icons/FoodDetail/AddIcon'
import { convertPrice } from '~/utils'
import { PlusIconV2 } from '~/assets/icons'
import { useAppContext } from '~/contexts/AppContext'
import {
  calcTotalQuantityByFoodID,
  checkFoodItemHasTopping,
  dataCartSelector,
  handleDecreaseFoodInRecommend,
  handleIncreaseFoodInRecommend,
} from '~/redux/cartSlice'
import { useDispatch, useSelector } from 'react-redux'

const cx = classNames.bind(styles)

const RecommendItem = ({ id, price, name, image, original_price }) => {
  const dataCart = useSelector(dataCartSelector) // Toàn bộ data cart
  const isDiscounted = original_price > price

  const quantity = calcTotalQuantityByFoodID(dataCart, id)
  const dispatch = useDispatch()
  const { handleOpenPopupFoodDetail } = useAppContext()

  // Xử lý bấm vào nút cộng đứng một mình
  const handleAdd = () => {
    handleOpenPopupFoodDetail({ idFood: id })
  }

  // Hàm giảm món ăn
  const handleDecrease = () => {
    dispatch(
      handleDecreaseFoodInRecommend({
        foodId: id,
      }),
    )
  }

  // Hàm tăng món ăn
  const handleIncrease = () => {
    const hasTopping = checkFoodItemHasTopping(dataCart, id)
    if (hasTopping) {
      handleOpenPopupFoodDetail({ idFood: id })
      return
    }

    dispatch(
      handleIncreaseFoodInRecommend({
        foodId: id,
      }),
    )
  }

  const renderQuantityController = () => {
    if (quantity <= 0)
      return (
        <div className={cx('controls_wrapper')}>
          <Button className={cx('add_btn')} onClick={handleAdd}>
            <PlusIconV2 />
          </Button>
        </div>
      )

    return (
      <div className={cx('controls_wrapper')}>
        <Box component="div" className={cx('controls')}>
          <Button className={cx('control_btn')} onClick={handleDecrease}>
            <SubtractIcon size="13px" />
          </Button>
          <Box component="span" className={cx('number_quantity')}>
            {quantity}
          </Box>
          <Button className={cx('control_btn')} onClick={handleIncrease}>
            <AddIcon size="13px" />
          </Button>
        </Box>
      </div>
    )
  }

  const renderPrice = () => {
    return (
      <Box component="div" className={cx('price_wrap', { isDiscounted })}>
        <Box component="p" className={cx('original')}>
          {convertPrice(original_price)}
        </Box>
        <Box component="p" className={cx('price')}>
          {convertPrice(price)}
        </Box>
      </Box>
    )
  }

  return (
    <Box component="article" className={cx('wrapper')}>
      <CardMedia component="img" image={image} className={cx('image')} onClick={handleAdd} />
      <Box component="h2" className={`${cx('name')} text-line-2`}>
        {name}
      </Box>
      {renderPrice()}
      {renderQuantityController()}
    </Box>
  )
}

RecommendItem.propTypes = {
  id: PropTypes.number,
  price: PropTypes.number,
  original_price: PropTypes.number,
  name: PropTypes.string,
  recommend_menu: PropTypes.bool,
  description: PropTypes.string,
  image: PropTypes.string,
}

export default RecommendItem
